module.exports = __webpack_public_path__ + "static/media/image-1-min.ad88ccb9.png";